/**
 * Traditional Chinese (zh-TW) translations for health analysis.
 * Detailed body-part and star interpretations fall back to zh-CN via the
 * fallback chain. Only top-level labels are overridden here.
 */
const health = {
  health: {
    title: "健康分析",
    basedOnStars: "根據您的星位",
    potentialAreas: "潛在的領域",
    disclaimer:
      "此健康分析基於占星詮釋，不應取代專業醫療建議。",
  },
};

export default health;
